import { Choice } from '@abiglobalhealth/go-types'
import { createContext, Dispatch, PropsWithChildren, SetStateAction, useEffect, useState } from 'react'

export interface ChoicesContextProps {
  choices: Choice[]
  setChoices: Dispatch<SetStateAction<Choice[]>>
}

export const ChoicesContext = createContext({} as ChoicesContextProps)

export const ChoicesProvider = ({ children }: PropsWithChildren) => {
  const [choices, setChoices] = useState<ChoicesContextProps['choices']>([])

  useEffect(() => {
    if (!choices) return

    localStorage.setItem('choices', JSON.stringify(choices))
  }, [choices])

  useEffect(() => {
    const lsChoices = localStorage.getItem('choices')

    setChoices(lsChoices ? JSON.parse(lsChoices) : [])
  }, [])

  const value = {
    choices,
    setChoices
  }

  return <ChoicesContext.Provider value={value}>{children}</ChoicesContext.Provider>
}
